import { NavLink } from 'react-router-dom';
import { cn } from '../client/cn';

type MenuButtonProps = {
  to: string;
  icon?: React.ReactNode;
  isSubItem?: boolean;
  onClick?: () => void;
} & React.PropsWithChildren;

const MenuButton = ({ to, icon, children, isSubItem = false, onClick }: MenuButtonProps) => {
  return (
    <NavLink
      to={to}
      end
      onClick={onClick}
      className={({ isActive }) =>
        cn(
          'group relative flex items-center gap-2.5 py-2 transition-colors',
          {
            'px-3': !isSubItem,
            'px-0': isSubItem,
            'text-blue-600 dark:text-blue-400': isActive,
            'text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200': !isActive,
            'hover:bg-gray-50 dark:hover:bg-gray-800/50': !isSubItem,
            'text-sm font-medium': !isSubItem,
            'text-[13px]': isSubItem
          }
        )
      }
    >
      {icon && !isSubItem && (
        <span className={cn(
          'flex-shrink-0',
          'text-gray-500 group-hover:text-gray-700 dark:text-gray-400 dark:group-hover:text-gray-300',
        )}>
          {icon}
        </span>
      )}
      <span className="truncate">{children}</span>
    </NavLink>
  );
};

export default MenuButton;